import React__default from "react";
import { ButtonNavigation } from "../../button-navigation/button-navigation.mjs";
import { TabsNavigation } from "../../tabs-navigation/tabs-navigation.mjs";
import { TabsNavigationItem } from "../../tabs-navigation/tabs-navigation-item.mjs";
import { TabsContext } from "./tabs.mjs";
const TabsNav = (props) => {
  const { items, "aria-labelledby": labelledBy, ...rest } = props;
  const innerElement = React__default.useRef(null);
  const context = React__default.useContext(TabsContext);
  const { navigationType, size, align, iconPosition, background, border, fullWidth } = context;
  const BEM = () => {
    const classArray = ["tabs__nav"];
    if (navigationType) {
      classArray.push("tabs__nav--".concat(navigationType));
    }
    if (hasIcons(items)) {
      classArray.push("tabs__nav--with-icons");
    }
    if (iconPosition) {
      classArray.push("tabs__nav--icons-".concat(iconPosition));
    }
    return classArray.join(" ");
  };
  const handleKeyUp = (event) => {
    event.preventDefault();
    event.stopPropagation();
    let tabs = [];
    if (innerElement.current instanceof Element) {
      tabs = Array.from(innerElement.current.querySelectorAll('[role="tab"]'));
    }
    const focusPosition = document.activeElement ? tabs.indexOf(document.activeElement) : 0;
    switch (event.key) {
      case "ArrowLeft":
      case "ArrowUp":
        if (focusPosition > 0) {
          focusTab(focusPosition - 1, tabs);
        } else {
          focusTab(tabs.length - 1, tabs);
        }
        break;
      case "ArrowRight":
      case "ArrowDown":
        if (focusPosition < tabs.length - 1) {
          focusTab(focusPosition + 1, tabs);
        } else {
          focusTab(0, tabs);
        }
        break;
      case "Home":
        focusTab(0, tabs);
        break;
      case "End":
        focusTab(tabs.length - 1, tabs);
        break;
      case " ":
      case "Enter": {
        if (event.target instanceof HTMLElement) {
          const tab = event.target;
          tab.click();
        }
        break;
      }
    }
  };
  const focusTab = (index, tabs) => {
    const element = tabs[index];
    element.focus();
    element.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center"
    });
  };
  const handleKeyDown = (event) => {
    switch (event.key) {
      case "ArrowLeft":
      case "ArrowUp":
      case "ArrowRight":
      case "ArrowDown":
      case " ":
        event.preventDefault();
        break;
    }
  };
  const getNavigationTypeTriggers = () => {
    const navItems = items.map((item) => ({
      id: item.id,
      current: item.current || false,
      label: item.text,
      onClick: (event) => {
        event.preventDefault();
        if (item.onClick) {
          item.onClick(event);
        }
      },
      url: item.url,
      role: "tab",
      tabIndex: item.current ? 0 : -1,
      "aria-selected": item.current,
      purpose: item.type || "default",
      icon: item.icon,
      endContent: item.tagContent
    }));
    if (navigationType === "button-navigation") {
      return /* @__PURE__ */ React__default.createElement(
        ButtonNavigation,
        {
          size: size === "small" ? "small" : void 0,
          align: align === "left" ? "left" : "center",
          items: navItems.map(({ endContent, icon, ...item }) => {
            return item;
          }),
          behaviour: "tabs",
          "aria-labelledby": labelledBy,
          elementRef: innerElement
        }
      );
    } else {
      return /* @__PURE__ */ React__default.createElement(
        TabsNavigation,
        {
          ref: innerElement,
          "aria-labelledby": labelledBy,
          behaviour: "tabs",
          iconPosition,
          background,
          align,
          size: size === "huge" ? "huge" : void 0,
          bordered: border !== "none",
          fullWidth
        },
        navItems.map(({ label, ...item }, index) => {
          var _a;
          return /* @__PURE__ */ React__default.createElement(TabsNavigationItem, { ...item, key: (_a = item.id) != null ? _a : index }, label);
        })
      );
    }
  };
  return /* @__PURE__ */ React__default.createElement("div", { className: BEM(), onKeyUp: handleKeyUp, onKeyDown: handleKeyDown, ...rest }, getNavigationTypeTriggers());
};
function hasIcons(items) {
  return items.some((i) => !!i.icon);
}
export {
  TabsNav
};
